export default {
      id: "icon-arrow-left-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-arrow-left",
      toString: function () {
        return this.url;
      }
    }